import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Colors, CommonFonts } from '@/theme';

const useStyles = makeStyles((theme) =>
  createStyles({
    boxTable: {
      marginTop: theme.spacing(7),
    },
  })
);

export default useStyles;
